(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4compact-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('compact-hero-carousel')) {
    class CompactHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.teardown();

        this.track = this.querySelector('[data-chc-track]');
        this.slides = Array.from(this.querySelectorAll('[data-chc-slide]'));
        if (!this.track || this.slides.length === 0) return;

        this.abort = new AbortController();
        const { signal } = this.abort;

        this.dots = Array.from(this.querySelectorAll('[data-chc-dot]'));
        this.prevBtn = this.querySelector('[data-chc-prev]');
        this.nextBtn = this.querySelector('[data-chc-next]');
        this.toggleBtn = this.querySelector('[data-chc-toggle]');

        // Single source of truth: attributes rendered from the section schema.
        this.interval = Math.max(2000, Number(this.dataset.interval) || 6000);
        this.loop = this.dataset.loop === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.canAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;

        this.index = 0;
        this.target = null;
        this.timer = null;
        this.startedAt = 0;
        this.remaining = this.interval;
        this.holds = new Set();

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reduced = reduced;

        // Reasons autoplay is held. Autoplay only runs while this set is empty.
        if (reduced) this.holds.add('user');
        if (document.hidden) this.holds.add('hidden');
        if ('IntersectionObserver' in window) this.holds.add('offscreen');

        this.bindControls(signal);
        this.bindAutoplayGuards(signal);
        this.bindEditorEvents(signal);
        this.observe();

        this.updateUI();
        this.updateToggle();
        this.sync();
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        this.teardown();
      }

      teardown() {
        this.abort?.abort();
        this.abort = null;
        this.slideObserver?.disconnect();
        this.viewObserver?.disconnect();
        this.resizeObserver?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
        clearTimeout(this.targetTimer);
        this.timer = null;
      }

      /* ---------- Events ---------- */

      bindControls(signal) {
        this.prevBtn?.addEventListener('click', () => this.goTo(this.index - 1), { signal });
        this.nextBtn?.addEventListener('click', () => this.goTo(this.index + 1), { signal });

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i), { signal });
        });

        this.toggleBtn?.addEventListener('click', () => {
          if (this.holds.has('user')) this.release('user');
          else this.hold('user');
          this.updateToggle();
        }, { signal });

        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const forward = (event.key === 'ArrowRight') !== rtl;
          this.goTo(this.index + (forward ? 1 : -1));
        }, { signal });

        // Any scrolling (swipe, wheel, programmatic) holds the timer until it settles.
        this.track.addEventListener('scroll', () => {
          this.hold('scroll');
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.release('scroll'), 150);
        }, { passive: true, signal });
      }

      bindAutoplayGuards(signal) {
        if (this.pauseOnHover) {
          this.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') this.hold('hover');
          }, { signal });
          this.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') this.release('hover');
          }, { signal });
        }

        // Keyboard focus pauses; mouse clicks on buttons do not leave it stuck.
        this.addEventListener('focusin', (event) => {
          if (event.target.matches(':focus-visible')) this.hold('focus');
        }, { signal });
        this.addEventListener('focusout', () => this.release('focus'), { signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.hold('hidden');
          else this.release('hidden');
        }, { signal });
      }

      bindEditorEvents(signal) {
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-chc-slide]');
          const i = this.slides.indexOf(slide);
          if (i < 0) return;
          this.hold('editor');
          this.goTo(i);
        }, { signal });

        this.addEventListener('shopify:block:deselect', () => this.release('editor'), { signal });
      }

      observe() {
        // Keep the active index in sync with manual swipes.
        this.slideObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const i = this.slides.indexOf(entry.target);
            if (i < 0) return;
            if (this.target !== null) {
              if (i !== this.target) return; // ignore slides passed mid-animation
              this.target = null;
            }
            this.setIndex(i);
          });
        }, { root: this.track, threshold: 0.6 });
        this.slides.forEach((slide) => this.slideObserver.observe(slide));

        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) this.release('offscreen');
            else this.hold('offscreen');
          }, { threshold: 0.2 });
          this.viewObserver.observe(this);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            const left = this.offsetFor(this.index);
            if (Math.abs(this.track.scrollLeft - left) > 2) {
              this.track.scrollTo({ left, behavior: 'instant' });
            }
          });
          this.resizeObserver.observe(this.track);
        }
      }

      /* ---------- Navigation ---------- */

      offsetFor(index) {
        const dir = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        return dir * this.track.clientWidth * index;
      }

      goTo(requested) {
        const count = this.slides.length;
        const next = this.loop
          ? (requested + count) % count
          : Math.min(Math.max(requested, 0), count - 1);

        if (next === this.index) return;

        const distance = Math.abs(next - this.index);
        const behavior = this.reduced || distance > 1 ? 'auto' : 'smooth';

        this.target = next;
        clearTimeout(this.targetTimer);
        this.targetTimer = setTimeout(() => { this.target = null; }, 1200);

        this.setIndex(next);
        this.track.scrollTo({ left: this.offsetFor(next), behavior });
      }

      setIndex(index) {
        if (index === this.index) return;
        this.index = index;
        this.updateUI();
        this.stopTimer();
        this.remaining = this.interval;
        this.sync();
      }

      advance() {
        const last = this.slides.length - 1;
        if (this.index >= last && !this.loop) {
          this.sync();
          return;
        }
        this.goTo(this.index + 1);
      }

      /* ---------- Autoplay ---------- */

      hold(reason) {
        if (this.holds.has(reason)) return;
        this.holds.add(reason);
        this.sync();
      }

      release(reason) {
        if (!this.holds.delete(reason)) return;
        this.sync();
      }

      sync() {
        const atEnd = !this.loop && this.index === this.slides.length - 1;
        const shouldRun = this.canAutoplay && !atEnd && this.holds.size === 0;

        if (shouldRun && !this.timer) this.startTimer();
        else if (!shouldRun && this.timer) this.stopTimer();

        if (this.canAutoplay) this.setAttribute('data-playing', String(shouldRun));
        this.track.setAttribute('aria-live', shouldRun ? 'off' : 'polite');
      }

      startTimer() {
        this.startedAt = performance.now();
        this.timer = setTimeout(() => {
          this.timer = null;
          this.advance();
        }, Math.max(this.remaining, 100));
      }

      stopTimer() {
        if (!this.timer) return;
        clearTimeout(this.timer);
        this.timer = null;
        this.remaining = Math.max(this.remaining - (performance.now() - this.startedAt), 100);
      }

      /* ---------- UI state ---------- */

      updateUI() {
        const last = this.slides.length - 1;

        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('inert', i !== this.index);
        });

        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });

        if (this.prevBtn) this.prevBtn.disabled = !this.loop && this.index === 0;
        if (this.nextBtn) this.nextBtn.disabled = !this.loop && this.index === last;
      }

      updateToggle() {
        if (!this.toggleBtn) return;
        const paused = this.holds.has('user');
        this.setAttribute('data-user-paused', String(paused));
        this.toggleBtn.setAttribute(
          'aria-label',
          paused ? this.toggleBtn.dataset.labelPlay : this.toggleBtn.dataset.labelPause
        );
      }
    }

    customElements.define('compact-hero-carousel', CompactHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
